export default "__VITE_ASSET__CzMxtIkI__"